<template>

  <div>
    
    <div v-if="permissions.includes('manage_candidates')">
      
      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To add an evaluation, select a job') }}
      </div>

      <div
        v-if="selectedJob"
        class="card">
        <div class="card-body">
          <CandidateEvaluationForm
            :initValue="{}"
            @created="created" />
        </div>
      </div>

    </div>

    <CandidateFeed :activityType="'evaluation'" />

  </div>

</template>

<script>
import CandidateEvaluationForm from './CandidateEvaluationForm'
import CandidateFeed from '../Feed/CandidateFeed'

export default {
  name: 'CandidateEvaluation',
  components: {
    CandidateEvaluationForm,
    CandidateFeed
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
    created (evaluation) {
      return this.$store.dispatch('refreshSelectActivities')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Evaluation/CandidateEvaluation.vue